import * as tslib_1 from "tslib";
import { OnInit, ViewContainerRef } from '@angular/core';
import { NodeType } from '../../../classes/tree/IBaseNode';
import { ECSNode } from '../../../classes/tree/nodes/ECSNode';
import { Tree } from '../../../classes/tree/tree';
import { DocumentService } from '../../../services/document.service';
import { LogLevel } from '../../../types';
import { BaseComponent } from '../../base.component';
var TreeExplorerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TreeExplorerComponent, _super);
    function TreeExplorerComponent(vcr, documentService, loggingService) {
        var _this = _super.call(this, vcr) || this;
        _this.documentService = documentService;
        _this.loggingService = loggingService;
        _this.NodeType = NodeType;
        _this.asc = true;
        _this.outsideClickHandler = function () {
            _this.toggleDropdown();
        };
        _this.insideClickHandler = function (e) {
            e.stopPropagation();
        };
        return _this;
    }
    Object.defineProperty(TreeExplorerComponent.prototype, "documents", {
        get: function () {
            return this._documents;
        },
        set: function (value) {
            var _this = this;
            this._documents = value.filter(function (d) { return !_this.documentService.isImage(d) && !_this.documentService.isVideo(d); });
            this.updateDocSources();
        },
        enumerable: true,
        configurable: true
    });
    TreeExplorerComponent.prototype.ngOnInit = function () { };
    TreeExplorerComponent.prototype.navigateToNode = function (node) {
        try {
            this.loading = false;
            if (node.children.length > 0) {
                this.currentNode = node;
                // set this.asc and this.orderby
                this.asc = node.data.asc || true;
                if (node.data.orderBy) {
                    this.orderBy = node.data.orderBy;
                }
                this.sortChildren(node, this.orderBy, this.asc);
            }
            else {
                this.currentNode = node.parent; // Didn't find data, return user to parent node
            }
            return this.currentNode;
        }
        catch (error) {
            this.loggingService.Log(error, LogLevel.Error);
        }
    };
    TreeExplorerComponent.prototype.updateDocSources = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rootNode, tree, names;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (this.documents && this.documents.length > 0) {
                    rootNode = new ECSNode();
                    rootNode.name = 'Documents';
                    rootNode.description = 'Documents';
                    rootNode.orderBy = 'documentType';
                    tree = new Tree(rootNode);
                    tree.children = this.documents.map(function (d) { return new Tree(new ECSNode(d)); });
                    names = Object.keys(tree.children[0].data.record);
                    tree.data.columns = names.map(function (name) {
                        return { name: name, alias: _this.camelCaseToAlias(name) };
                    });
                    this.navigateToNode(tree);
                }
                return [2 /*return*/];
            });
        });
    };
    TreeExplorerComponent.prototype.camelCaseToAlias = function (columnName) {
        var lastPart = 0;
        var parts = [];
        for (var i = 1; i <= columnName.length; i++) {
            if (i === columnName.length || (columnName[i] >= 'A' && columnName[i] <= 'Z')) {
                parts.push(columnName.substring(lastPart, i));
                lastPart = i;
            }
        }
        // Capitalize the first part
        parts[0] = parts[0][0].toUpperCase() + parts[0].substring(1);
        return parts.join(' ');
    };
    TreeExplorerComponent.prototype.onMouseEnter = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    TreeExplorerComponent.prototype.onMouseLeave = function () {
    };
    TreeExplorerComponent.prototype.toggleDropdown = function (event) {
        if (event) {
            var target = event.target || event.srcElement || event.currentTarget;
            var dropdown = target.offsetParent.nextElementSibling || target.nextElementSibling;
            dropdown.classList.toggle('show');
            this.openedDropdown = dropdown;
            window.addEventListener('mousedown', this.outsideClickHandler);
            window.addEventListener('dragstart', this.outsideClickHandler);
            this.openedDropdown.addEventListener('mousedown', this.insideClickHandler);
        }
        else {
            this.openedDropdown.classList.toggle('show');
            window.removeEventListener('mousedown', this.outsideClickHandler);
            window.removeEventListener('dragstart', this.outsideClickHandler);
            this.openedDropdown.removeEventListener('mousedown', this.insideClickHandler);
            this.openedDropdown = null;
        }
    };
    TreeExplorerComponent.prototype.toggleAccordion = function (event) {
        var target = event.target || event.srcElement || event.currentTarget;
        var panel = target.nextElementSibling;
        target.classList.toggle('active');
        if (panel.style.display === 'block') {
            panel.style.display = 'none';
        }
        else {
            panel.style.display = 'block';
        }
    };
    TreeExplorerComponent.prototype.sortChildren = function (node, orderBy, asc) {
        this.groups = null;
        var sortOrder = asc ? 1 : -1;
        var collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' });
        if (orderBy) {
            switch (node.children[0].data.nodeType) {
                case NodeType.Record:
                    this.groups = this.buildGroups(node, orderBy);
                    this.groups.sort(function (a, b) { return sortOrder * collator.compare(a[0].split(': ')[1], b[0].split(': ')[1]); });
                    break;
                case NodeType.Document:
                    var alias_1 = node.data.columns.find(function (c) { return c.name === orderBy; }).alias;
                    // TODO: Consider making documents data.records the same as Record nodes have.
                    //       Just need data.columnList and change data.records to an array of strings.
                    var groups = node.children.reduce(function (acc, child) {
                        (acc[alias_1 + ": " + child.data.record[orderBy]] = acc[alias_1 + ": " + child.data.record[orderBy]] || []).push(child);
                        return acc;
                    }, {});
                    this.groups = Object.entries(groups);
                    this.groups.sort(function (a, b) { return sortOrder * collator.compare(a[0].split(': ')[1], b[0].split(': ')[1]); });
                    break;
                default:
                    var idx_1 = node.children[0].data.columnList.indexOf(orderBy);
                    if (idx_1 <= 0) {
                        var column = node.data.columns.find(function (c) { return c.alias = orderBy; });
                        idx_1 = node.children[0].data.columnList.indexOf(column.name);
                    }
                    node.children.sort(function (a, b) { return sortOrder * collator.compare(a.data.record[idx_1], b.data.record[idx_1]); });
                    break;
            }
        }
        else {
            node.children.sort(function (a, b) { return sortOrder * collator.compare(a.name, b.name); });
        }
        this.currentNode.data.asc = asc;
        this.currentNode.data.orderBy = orderBy;
    };
    return TreeExplorerComponent;
}(BaseComponent));
export { TreeExplorerComponent };
